export default __webpack_public_path__ + "static/LogoNavbar-6bcdc65ffcde7ea81b2e4abf189f4c88.svg";